import { classNames } from 'libs/react';
import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './Alert.scss';
/**
 * @component Alert
 * @since 1.0.0
 */
export function Alert(props) {
    let { style, picto, title, infos, error, field } = Object.assign({ style: 'success', picto: 'fal check' }, props);
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    function onClose() {
        if (props.onClose) {
            props.onClose();
        }
    }
    if (error) {
        style = 'error';
        picto = 'exclamation';
        for (const graphQLError of error.graphQLErrors) {
            title = getErrorTitle(graphQLError);
            infos = getErrorInfos(graphQLError);
            if (field) {
                const value = graphQLError.extensions &&
                    graphQLError.extensions.fields &&
                    graphQLError.extensions.fields[field];
                if (value) {
                    infos = value;
                }
            }
            if (title) {
                break;
            }
        }
        if (title == '' || title == null)
            title = getNetworkErrorTitle(error);
        if (title == '' || title == null)
            title = getDefaultErrorTitle(error);
    }
    if (picto == null) {
        switch (style) {
            case 'success':
                picto = 'check';
                break;
            case 'info':
                picto = 'info';
                break;
            case 'warning':
                picto = 'exclamation';
                break;
            case 'error':
                picto = 'times';
                break;
        }
    }
    const className = classNames('alert', 'alert--' + style);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "alert-main" },
            React.createElement("div", { className: "alert-head" }, picto && React.createElement(Icon, { className: "alert-picto", value: picto })),
            React.createElement("div", { className: "alert-body" },
                title && React.createElement(Text, { className: "alert-title", value: title }),
                infos && React.createElement(Text, { className: "alert-infos", value: infos })),
            React.createElement(Button, { className: "alert-close", style: "picto", picto: "times", onPress: onClose }))));
}
/**
 * @function getErrorTitle
 * @since 1.0.0
 * @hidden
 */
function getErrorTitle(error) {
    return error.message;
}
/**
 * @function getErrorInfos
 * @since 1.0.0
 * @hidden
 */
function getErrorInfos(error) {
    return error.extensions && error.extensions.description;
}
/**
 * @function getNetworkErrorTitle
 * @since 1.0.0
 * @hidden
 */
function getNetworkErrorTitle(error) {
    const networkError = error.networkError;
    if (networkError == null) {
        return null;
    }
    return (networkError &&
        networkError.result &&
        networkError.result.errors &&
        networkError.result.errors[0] &&
        networkError.result.errors[0].message);
}
/**
 * @function getNetworkErrorTitle
 * @since 1.0.0
 * @hidden
 */
function getDefaultErrorTitle(error) {
    return error.message.replace('GraphQL error:', '');
}
